import { defineNuxtRouteMiddleware} from "nuxt/app";
import { useTopbarFilterStore } from "@/store/topbarFilterStore";
import { useQuickFilterStore } from "@/store/quickFilterStore";
import { DEFAULT_FILTER_STATE } from "@/constants/filter";

export default defineNuxtRouteMiddleware(async (to) => {
  const filterStore = useTopbarFilterStore();
  const quickFilterStore = useQuickFilterStore();

  let viewId = undefined;

  // Get and set filter view list
  await quickFilterStore.setQuickFilterItemsAsync();

  // Get and set shared link data if the linkId is present in the query params
  const jobId = to.query?.job as string;  
  if (jobId) {
    await filterStore.setAnalyticsJobFilterAsync(jobId);
    // Get viewId from shared link or use default
    viewId = filterStore.analyticsJobFilter?.quickFilterId || DEFAULT_FILTER_STATE.id;
    quickFilterStore.setSelectedQuickFilterById(viewId, false);
  }

  return;
});